import React, { Component } from 'react';
import { attachLocale } from '../../../../lib/utils';
import { apiSearchAlgolia } from '../../../../lib/apiQueries';

// *** ALL SEARCH BAR COMPONENTS INHERITS THIS COMPONENT ***
class SearchBarContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shops: [],
      categories: [],
      isMouseOver: false,
      value: '',
    };

    this.mouseEnter = this.mouseEnter.bind(this);
    this.mouseLeave = this.mouseLeave.bind(this);
    this.hideResults = this.hideResults.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  onSearch(e, locale) {
    e.preventDefault();
    if (!this.state.value) {
      return;
    }

    const searchUrl = `/search?q=${this.state.value}`;
    const resolvedUrl = attachLocale(searchUrl, locale);
    window.location.href = resolvedUrl;
  }

  clearSearch() {
    this.setState({
      shops: [],
      categories: [],
    });
  }

  hideResults() {
    if (!this.state.isMouseOver) {
      this.setState({
        showIcon: false,
        value: '',
      });
      this.clearSearch();
    }
  }

  mouseEnter() {
    this.setState({
      isMouseOver: true,
    });
  }

  mouseLeave() {
    this.setState({
      isMouseOver: false,
    });
  }

  handleChange(e) {
    const { locale } = this.props;

    const searchValue = e.target.value;

    this.setState({
      value: searchValue,
    });

    if (!searchValue) {
      this.clearSearch();
      return;
    }

    apiSearchAlgolia(searchValue, { hitsPerPage: 5 }, 'shops', locale)
      .then(content => {
        this.setState({
          shops: content.hits
        })
      })
      .catch(err => console.error(err));
     
    apiSearchAlgolia(searchValue, { hitsPerPage: 5 }, 'categories', locale)
      .then(content => {
        this.setState({
          categories: content.hits,
        })
      })
      .catch(err => console.error(err));
  }

  // render() from subclass
}

export default SearchBarContainer;
